export interface DataleanUpdateEntityResponse {
  acknowledged: boolean;
  matchedCount?: number;
  modifiedCount?: number;
  organizationUUID?: string;
  upsertedCount?: number;
  upsertedId?: string|null;
  uuid: string;
}
